export default __webpack_public_path__ + "static/media/s10.a3a4279b.png";